import { Component, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { TrelloCardService } from "../../models/integrations/trello-card.service";

@Component({
  selector: "ab-trello-integration",
  templateUrl: "./trello.component.html",
})
export class TrelloIntegrationComponent implements OnInit {
  @Input() public notice: any;

  public loading: boolean;
  public card: any;
  public creatingCard: boolean;
  public error: any;
  public removingCard: boolean;

  constructor(private trelloCardService: TrelloCardService) {}

  public ngOnInit() {
    this.loading = true;

    return this.trelloCardService
      .get(this.notice)
      .pipe(
        finalize(() => {
          delete this.loading;
        }),
      )
      .subscribe((card: any) => {
        this.card = card;
      });
  }

  public createCard() {
    this.card = { notice: this.notice };

    this.creatingCard = true;
    return this.trelloCardService
      .create(this.card)
      .pipe(
        finalize(() => {
          delete this.creatingCard;
        }),
      )
      .subscribe((data: any) => {
        if (data.error) {
          this.error = data.error;
        }
      });
  }

  public removeCard() {
    this.card = { notice: this.notice };

    this.removingCard = true;
    return this.trelloCardService
      .destroy(this.card)
      .pipe(
        finalize(() => {
          delete this.removingCard;
        }),
      )
      .subscribe(() => {
        delete this.card;
      });
  }
}
